import { useTranslation } from 'react-i18next';
import { useInfiniteHits, useInstantSearch } from 'react-instantsearch';
import { Button } from '@fpsm/cxy-components/Button';

import { type BetInsightsConfig } from '~/configuration/BetInsightsConfiguration';
import { type BettingInsightsContent, type BettingInsightsResult, type EsIndex } from '~/configuration/types';

import styles from './styles/BettingInsights.module.scss';

export function BettingInsightsPagination<
  TIndex extends EsIndex,
  TContent extends BettingInsightsContent<TIndex>,
  TResult extends BettingInsightsResult<TIndex>,
>({ config }: { config: BetInsightsConfig<TIndex, TContent> }) {
  const { isLastPage, items, showMore } = useInfiniteHits<TResult>();
  const { t } = useTranslation();
  const { status } = useInstantSearch();

  const hasResults = Boolean(items.length);
  const isLoadingResults = status !== 'idle';
  const isLoadingMoreResults = isLoadingResults && hasResults;
  const shouldShowMore = !config.isWalled && !isLastPage;

  if (!shouldShowMore) {
    return null;
  }
  return (
    <section className={styles.bettingInsightsPagination}>
      {items?.length > 0 && (
        <Button
          className={styles.loadMore}
          isLoading={isLoadingMoreResults}
          loadingText={t('CX_LOADING')}
          onClick={showMore}
          size="large"
          variant="tertiary"
        >
          {t('CX_LOAD_MORE')}
        </Button>
      )}
    </section>
  );
}
